import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from "react";
export const defaultObsinaMessages = {
    close: "Close",
    dismiss: "Dismiss",
    loading: "Loading",
    menu: "More actions",
    dataTable: "Data table",
    toastRegion: "Notifications",
    progress: "Progress",
    removeTag: (label) => `Remove ${label}`,
    status: {
        synced: "Synced",
        syncing: "Syncing",
        error: "Needs attention",
        paused: "Paused",
        offline: "Offline",
        healthy: "Synced",
        partial: "Synced with issues",
        reauth: "Sign-in expired",
        disconnected: "Not connected",
    },
};
export function resolveObsinaMessages(input) {
    return {
        ...defaultObsinaMessages,
        ...input,
        status: {
            ...defaultObsinaMessages.status,
            ...input?.status,
        },
    };
}
const ObsinaI18nContext = createContext({
    locale: "en",
    messages: defaultObsinaMessages,
});
export function ObsinaProvider({ children, locale = "en", messages, }) {
    const value = useMemo(() => ({ locale, messages: resolveObsinaMessages(messages) }), [locale, messages]);
    return (_jsx(ObsinaI18nContext.Provider, { value: value, children: children }));
}
export function useObsinaI18n() {
    return useContext(ObsinaI18nContext);
}
//# sourceMappingURL=i18n.js.map